module.exports = __webpack_public_path__ + "static/media/peopleGrid-01_v2.85327b61.jpg";